module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    attrs: {
      "data-text": "U"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "N"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "I"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "Q"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "I"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "T"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "T"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "Y"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-text": "🐱"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1726e59d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/furniture/Header.vue
// module id = 124
// module chunks = 2